/**
 * DOMPurifyを使って不要なタグを除去するDirective
 */

import type { DirectiveBinding } from 'vue'
import DOMPurify from 'dompurify'

let purify: any

if (import.meta.server) {
  const { JSDOM } = await import('jsdom')
  purify = DOMPurify(new JSDOM('').window)
} else {
  purify = DOMPurify(window)
}

function sanitizeHtml(binding: DirectiveBinding) {
  return (
    purify.sanitize(binding.value?.replace(/\\n/g, '<br>'), {
      ALLOWED_ATTR: ['href', 'target', 'rel'],
    }) || ''
  )
}

function created(el, binding) {
  el.innerHTML = sanitizeHtml(binding)
}
function updated(el, binding) {
  el.innerHTML = sanitizeHtml(binding)
}
function getSSRProps(binding) {
  return {
    innerHTML: sanitizeHtml(binding),
  }
}

export default { created, updated, getSSRProps }
